import React from 'react';
import { parseISO, format } from 'date-fns';
import clsx from 'clsx'

import useResult from 'hooks/useResult';
import Spinner from 'components/Spinner';

const Answer = ({answer_text, is_true}) => {
  return (
    <li>
      <p>{answer_text}</p>
    </li>
  )
}

const Question = ({index, answers, correct_answers, question_text, explanation_text, is_correct}) => {
  return (
    <div className="column is-full py-0">
      <div className={clsx("content", {"has-background-success-light": is_correct}, {"has-background-danger-light": !is_correct})}>
        <div className="p-5">
          <h3 className="title is-3">
            Question #{index}
          </h3>
          <h4 className="title is-4">
            Question
          </h4>
          <p>
            {question_text}
          </p>
          <div className="columns px-4 py-3">
            <div className="column">
              <h4 className="title is-4">Vos réponses</h4>
              <ul>
                {answers.map((answer) => <Answer {...answer} />)}
              </ul>
            </div>
            <div className="column">
              {!is_correct &&
              <>
              <h4 className="title is-4">Réponses attendues</h4>
              <ul>
                {correct_answers.map((answer) => <Answer {...answer} />)}
              </ul>
              </>
              }
            </div>
          </div>
          <h4 className="title is-4">Explication</h4>
          <p>
            {explanation_text}
          </p>
        </div>
      </div>
      <hr />
    </div>
  )
}

const ResultDisplay = ({name, started_at, ended_at, score, max_score, student_question}) => {
  const dateStart = parseISO(started_at);
  const dateEnd = ended_at ? parseISO(ended_at) : undefined;
  return (
    <div className="container p-4">
      <h1 className="title is-1">
        {name}
      </h1>
      <h3 className="title is-3">
        Score: {score}/{max_score}
      </h3>
      <p>Commencé le {format(dateStart, "dd/MM/yyyy HH'h'mm")}</p>
      <p>
        {dateEnd &&
          `Fini le ${format(dateEnd, "dd/MM/yyyy HH'h'mm")}`
        }
      </p>
      <br />
      <div className="columns is-multiline">
        {student_question.map((q, i) =>
          <Question {...q} index={i+1} />
        )}
      </div>
    </div>
  )
}

const Result = ({id}) => {
  const result = useResult(id);
  console.log(result)
  return (
    <>
      {result ?
      <ResultDisplay {...result} />
      :
      <Spinner size="3x" />
      }
    </>
  )
}

export default Result;